module.exports = __webpack_public_path__ + "img/zoom-logo.916321ba.svg";